import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import { SectionHeading } from "components/misc/Headings";

const HeadingRow = tw.div`flex`;
const Heading = tw(SectionHeading)`text-gray-900 mb-10`;
const Text = styled.div`
  ${tw`text-lg  text-gray-800`}
  p {
    ${tw`mt-2 leading-loose`}
  }
  h1 {
    ${tw`text-3xl font-bold mt-10`}
  }
  h2 {
    ${tw`text-2xl font-bold mt-8`}
  }
  h3 {
    ${tw`text-xl font-bold mt-6`}
  }
  ul {
    ${tw`list-disc list-inside`}
    li {
      ${tw`ml-2 mb-3`}
      p {
        ${tw`mt-0 inline leading-normal`}
      }
    }
  }
`;
export default ({ headingText = "Privacy Policy" }) => {
  return (

          <Text style={{textAlign: "justify", margin: "5% 10%"}}>

            <headingText style={{fontWeight: "bold", textAlign: "center"}}>Política de eliminación de datos</headingText>

            <p>
              Solicitud de Eliminación de Datos del Chatbot de Messenger de Bécalos

En Fundación Televisa, A.C., respetamos tu derecho a la privacidad y al control de tus datos personales.

Al interactuar con nuestro asistente virtual (chatbot) en Facebook Messenger, almacenamos tu identificador de usuario de Facebook (User ID) y el historial de la conversación para poder ofrecerte un servicio continuo y de calidad.

Cómo solicitar la eliminación de tus datos

Si deseas que eliminemos tu historial de conversación y los datos asociados a tu perfil de Facebook de nuestros registros, por favor sigue estos sencillos pasos:

Envía un correo electrónico a la siguiente dirección: contacto@odvz.com.mx .

En el asunto del correo, escribe: "Solicitud de Eliminación de Datos de Messenger".

En el cuerpo del correo, por favor incluye:

Tu nombre completo, tal como aparece en tu perfil de Facebook.

Una frase simple como: "Solicito la eliminación de todos mis datos asociados al chatbot de Bécalos en Facebook Messenger".

Una vez recibida tu solicitud, nuestro equipo la procesará y te enviaremos una confirmación por correo electrónico en un plazo no mayor a 15 días hábiles.
            </p>
          </Text>
  );
};
